import { useState, useEffect } from 'react';
import getAllFacilitiesForOffice from '../services/facilities.services';
import type Facility from '../../facilities/models/facility';
import { useKeycloak } from '../../authentication/keycloak/KeycloakProvider';

interface FacilitiesState {
  readonly initialized: boolean;
  readonly facilities?: Facility[];
  readonly error?: boolean;
}

interface Props {
  readonly officeId?: string | undefined;
}

const useFacilitiesForOffice = ({ officeId }: Props): FacilitiesState => {
  const [state, setState] = useState<FacilitiesState>({
    initialized: false,
  });
  const keycloak = useKeycloak();

  useEffect(() => {
    const getFacilities = async (): Promise<void> => {
      try {
        const facilities = (await getAllFacilitiesForOffice(officeId, keycloak)) ?? [];
        setState({ initialized: true, facilities });
      } catch (error) {
        setState({ initialized: false, error: true });
      }
    };

    if (!state.initialized) {
      getFacilities();
    }
  }, [state, officeId, keycloak]);

  return state;
};

export default useFacilitiesForOffice;
